<template>
  <b-col cols="12">
    <GenericTable
      id="tab_liste_thematiques"
      ref="genericTable"
      :actions="actions"
      :colonnes="cols[$store.getters.typeUser.nom]"
      endpoint-url="/liste"
      :filterable-col="filterableCol"
      :extra-filters="extraFilters"
      @row-click="openDetails"
      @action-callback="dispatchAction"
    />
    <ThematiqueModal />
    <ModalExportSimpleListe />
    <ModalExportDetailleListe />
  </b-col>
</template>

<script>
import GenericTable from "@/components/generics/genericTable/GenericTable.vue";
import ThematiqueModal from "@/components/thematiques/ThematiqueModal.vue";
import ModalExportSimpleListe from "@/components/commandes/ModalExportSimpleListe.vue";
import ModalExportDetailleListe from "@/components/commandes/ModalExportDetailleListe.vue";

import {
  verboseColNbOuvragesForTable,
  displayErrorSelectOne,
} from "@/modules/utils";

export default {
  name: "ListeThematiques",
  components: {
    GenericTable,
    ThematiqueModal,
    ModalExportSimpleListe,
    ModalExportDetailleListe,
  },
  data() {
    return {
      filterableCol: ["tenant__nom", "titre", "identifiant", "date"],
      cols: {
        "BIF / BIP": [
          {
            key: "tenant__nom",
            overrideName: "Équipe",
            overrideOrderingKey: "tenant__nom,identifiant",
          },
          { key: "identifiant" },
          { key: "titre" },
          { key: "date", defaultOrder: true, sensOrder: "-" },
          {
            key: "ouvrages_ids",
            overrideName: "Nombre d'ouvrage(s)",
            noOrder: true,
          },
          { key: "prix_total", overrideName: "Prix total ($)" },
        ],
        NH: [
          {
            key: "tenant__nom",
            overrideName: "Équipe",
            overrideOrderingKey: "tenant__nom,identifiant",
          },
          { key: "identifiant" },
          { key: "titre" },
          { key: "date", defaultOrder: true, sensOrder: "-" },
          {
            key: "nb_ouvrages",
            overrideName: "Nombre d'ouvrage(s)",
            noOrder: true,
          },
          { key: "prix_total", overrideName: "Prix total ($)" },
          { key: "dollars_en_stock" },
          { key: "stock_reel_total", overrideName: "Stock" },
          { key: "stock_reserve_total", overrideName: "Stock réservé" },
        ],
      },
      extraFilters: { tenant: this.$store.getters.typeUser.id },
    };
  },
  computed: {
    actions() {
      const actions = [
        { title: "Créer une liste", callback: "add" },
        {
          title: "Export simple",
          callback: "export-simple",
          selectionRelated: true,
        },
        {
          title: "Export détaillé",
          callback: "export-detaille",
          selectionRelated: true,
        },
      ];

      if (
        this.$store.state[this.$route.name]
        && this.$store.state[this.$route.name].displayArchived
      ) {
        actions.push({ title: "Désarchiver", callback: "unarchive" });
      } else {
        actions.push({ title: "Supprimer", callback: "delete" });
      }

      return actions;
    },
  },
  watch: {
    "$store.getters.typeUser.id": function watchTypeUser() {
      // Actualise la liste si un admin change de tenant
      this.extraFilters = { tenant: this.$store.getters.typeUser.id };
      setTimeout(() => {
        this.$store.dispatch(`${this.$route.name}/fetchData`);
      }, 100);
    },
  },
  mounted() {
    this.$store.commit(
      `${this.$route.name}/setFormatDataFunction`,
      verboseColNbOuvragesForTable,
    );
  },
  methods: {
    /**
     * Affiche la modale de la liste (thématique) avec ses détails.
     * @public
     * @param {Object} ouvrage Ouvrage sélectionné.
     */
    openDetails(thematique) {
      this.$modal.show("thematique", {
        thematique,
      });
    },
    /**
     * Exécute les actions du tableau des listes (thématiques).
     * @public
     * @param {String} actionCode Action sélectionnée.
     */
    dispatchAction(actionCode) {
      // On execute le dispatch générique qui gére le delete
      const resCode = this.$refs.genericTable.genericDispatch(
        actionCode,
        this.$route.name,
        "/liste",
      );

      if (resCode === -1) {
        const checkedRows = this.$store.getters[
          `${this.$route.name}/rowDisplayed`
        ].filter((row) => row._checkBoxChecked);

        switch (actionCode) {
          case "add":
            this.$modal.show("thematique", { new: true });
            break;

          case "export-simple":
            if (checkedRows.length === 1) {
              this.displayModalExportSimpleListe();
            } else {
              displayErrorSelectOne("une liste");
            }
            break;

          case "export-detaille":
            if (checkedRows.length === 1) {
              this.displayModalExportDetailleListe();
            } else {
              displayErrorSelectOne("une liste");
            }
            break;

          default:
            break;
        }
      }
    },
    /**
     * Affiche la modale d'export simple.
     * @public
     */
    displayModalExportSimpleListe() {
      const checkedRows = this.$store.getters[
        `${this.$route.name}/rowDisplayed`
      ].filter((row) => row._checkBoxChecked);

      this.$modal.show("ModalExportSimpleListe", {
        ligne: checkedRows[0],
      });
    },
    /**
     * Affiche la modale d'export détaillé.
     * @public
     */
    displayModalExportDetailleListe() {
      const checkedRows = this.$store.getters[
        `${this.$route.name}/rowDisplayed`
      ].filter((row) => row._checkBoxChecked);

      this.$modal.show("ModalExportDetailleListe", {
        ligne: checkedRows[0],
      });
    },
  },
};
</script>

<style lang="scss">
#tab_liste_thematiques {
  .identifiant { width: 200px; }

  .titre {
    width: 350px;
    min-width: 350px;
  }

  .date { width: 150px; }

  .nb_ouvrages { width: 100px; }

  .prix_total,
  .dollar_en_stock { width: 100px; }

  .stock_reel,
  .stock_reserve_total { width: 100px; }
}
</style>
